import React from "react";
import "./ImagingWhyUs.css";
import network from "../../Assets/global-network.svg";
import outline from "../../Assets/OutlineForImagingWhyUs.svg";
import salary from "../../Assets/salary.svg";
import surface1 from "../../Assets/surface1.svg";


function ImagingWhyUs(){
    return(
        <div className="ImagingWhyUsNewMain">
        <div className="ImagingWhyUsMain container">
           <h1>Why Redcliffe Imaging</h1>
           <div className="ImagingWhyUsDivMain container">
               <div className="TwoDivForImagingWhyUsDivMain">
           <div className="ImagingWhyUsDiv">
               <div className="ImagingWhyUsImage">
                    <img src={network} alt="mri"  />
               </div>
               <div className="ImagingWhyUsPara">
                   <h2>Largest network</h2>
                   <p>of high-quality imaging centres</p>
               </div>
           </div>
           <div className="ImagingWhyUsDiv">
               <div className="ImagingWhyUsImage">
                    <img src={outline} alt="mri"  />
               </div>
               <div className="ImagingWhyUsPara">
                   <h2>End To End Patient</h2>
                   <p>facilitation and assistance</p>
               </div>
           </div>
           </div>
           <div className="TwoDivForImagingWhyUsDivMain">
           <div className="ImagingWhyUsDiv">
               <div className="ImagingWhyUsImage">
                    <img src={salary} alt="mri"  />
               </div>
               <div className="ImagingWhyUsPara">
                   <h2>Most Affordable</h2>
                   <p>and transparent tests pricing</p>
               </div>
           </div>
           <div className="ImagingWhyUsDiv">
               <div className="ImagingWhyUsImage">
                    <img src={surface1} alt="mri"  />
               </div>
               <div className="ImagingWhyUsPara">
                   <h2>Accurate Reports</h2>
                   <p>from Accredited centres</p>
               </div>
           </div>
           </div>
           </div>
        </div>
        </div>
    )
}

export default ImagingWhyUs;